/*
 * @Date: 2021-03-01 15:59:00
 * @LastAuthor: @yangwenshan
 * @lastTime: 2021-10-08 17:09:05
 * @FilePath: \tmk\src\store\index.js
 */
/*
 * @Description:
 * @Author: xiaoyao
 * @since: 2020-03-04 10:33:06
 * @LastAuthor: xiaoyao
 * @lastTime: 2020-03-04 10:33:07
 */
import Vue from 'vue'
import Vuex from 'vuex'

import app from './modules/app'
import user from './modules/user'
import permission from './modules/permission'
import accounts from './modules/accounts'
import handout from './modules/handout'
import callList from './modules/call-list'
import organization from './modules/organization'
import orgSetting from './modules/orgSetting'
import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    user,
    permission,
    accounts,
    handout,
    callList,
    organization,
      orgSetting
  },
  state: {

  },
  mutations: {

  },
  actions: {

  },
  getters
})



// WEBPACK FOOTER //
// ./src/store/index.js